import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiResultModel, getPIMExportApi } from "@tecumseh/Services/PIMExportHistoryService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface Parameter {
    query?: any;
    onError?: (errorMessage: string) => void;
}

type HandlerType = CustomApiHandler<Parameter, ApiResultModel>;

export const StartLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/PIMExport/StartFetchingContents",
    });
};

export const GetContents: HandlerType = async props => {
    if (props.parameter.query) {
        try {
            const result = await getPIMExportApi({ query: props.parameter.query });
            props.dispatch({
                type: "Custom/PIMExport/SetContents",
                contentResults: result,
            });
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                props.apiResult.errorMessage = error.errorJson.message;
                return;
            }
            throw error;
        }
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.apiResult?.errorMessage) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};


export const chain = [StartLoading, GetContents, ExecuteOnErrorCallback];

const getPIMExport = createHandlerChainRunner(chain, "getPIMExport");
export default getPIMExport;
